import React, { useState } from "react";

//
import { Modal, Button } from "react-bootstrap";

// Video React
import {
  Player,
  ControlBar,
  VolumeMenuButton,
  BigPlayButton,
} from "video-react";

//
import DollarCostQuestion from "../../assets/img/dollar-cost-question.png";

//
import Poster from '../../assets/img/dollar-cost-video-poster.jfif'

function DCAQuestion() {
  const [show, setShow] = useState(false);
  return (
    <>
      <a className="outer-link pointer" onClick={() => setShow(true)}>
        Learn more
        <i className="las la-arrow-up"></i>
      </a>

      <Modal
        size="xl"
        id="learn-more-modal"
        centered
        show={show}
        onHide={() => setShow(false)}
      >
        <Modal.Header closeButton>
          <div style={{ backgroundImage: `url(${DollarCostQuestion})` }}>
            <h3>What is Dollar Cost Averaging Bitcoin?</h3>
          </div>
        </Modal.Header>
        <Modal.Body>
          <article>
            <div className="paragraph mb-0">
              <p>
                Dollar-cost averaging (DCA) is an investment strategy in which
                an investor divides up the total amount to be invested across
                periodic purchases of a target asset in an effort to reduce the
                impact of volatility on the overall purchase. The purchases
                occur regardless of the asset's price and at regular intervals.
              </p>
              <p>
                In effect, this strategy removes much of the detailed work of
                attempting to time the market in order to make purchases of
                equities at the best prices. Dollar-cost averaging is also known
                as the constant dollar plan.
              </p>
            </div>
            

            <div className="player">
              <Player
                playsInline
                download
                fluid={false}
                width="100%"
                height={360}
                poster={Poster}
              >

                <BigPlayButton position="center" />

                <source src='http://media.w3.org/2010/05/bunny/movie.mp4' />

                <ControlBar>
                  <VolumeMenuButton />
                </ControlBar>
              </Player>
            </div>

            <div className="paragraph">
              <h5>Understanding Dollar-Cost Averaging (DCA)</h5>
              <p>
                Dollar-cost averaging is a tool an investor can use to build
                savings and wealth over a long period. It is also a way for an
                investor to neutralize short-term volatility in the broader
                equity market. A prime example of dollar-cost averaging is its
                use in 401(k) plans, in which regular purchases are made
                regardless of the price of any given equity within the account.
              </p>
              <p>
                In a 401(k) plan, an employee can select a pre-determined amount
                of their salary that they wish to invest in a menu of mutual or
                index funds. When an employee receives their pay, the amount the
                employee has chosen to contribute to the 401(k) is invested in
                their investment choices.
              </p>
              <p>
                Dollar-cost averaging can also be used outside of 401(k) plans,
                such as mutual or index fund accounts. Although it's one of the
                more basic techniques, dollar-cost averaging is still one of the
                best strategies for beginning investors looking to trade ETFs.
              </p>
              <p>
                Additionally, many dividend reinvestment plans allow investors
                to dollar-cost average by making contributions regularly.
              </p>
            </div>

            <div className="paragraph">
              <h5>Real-World Example of Dollar-Cost Averaging</h5>
              <p>
                Joe works at ABC Corp. and has a 401(k) plan. He receives a
                paycheck of $1,000 every two weeks. Joe decides to allocate 10%
                or $100 of his pay to his employer’s plan. He chooses to
                contribute 50% of his allocation to a Large Cap Mutual Fund and
                50% to an S&P 500 Index Fund. Every two weeks 10%, or $100, of
                Joe’s pre-tax pay will buy $50 worth of each of these two funds
                regardless of the fund's price.
              </p>
              <p>
                The table below shows half of Joe's $100 contributions to the
                S&P 500 index fund over 10 pay periods. Throughout ten
                paychecks, Joe invested a total of $500, or $50 per week.
                However, because the price of the fund increased and decreased
                over several weeks Joe’s average price came to $10.48. The
                average was higher than his initial purchase, but it was lower
                than the fund’s highest prices. This allowed Joe to take
                advantage of the fluctuations of the market as the index fund
                increased and decreased in value.
              </p>
            </div>

            <div className="paragraph">
              <h5>How Dollar Cost Averaging Works</h5>
              <p>
                It is important to note that this example of the dollar-cost
                averaging strategy works out favorably because the hypothetical
                results of the S&P 500 Index fund ultimately rose over the
                period of time in question. Dollar-cost averaging does improve
                the performance of an investment over time, but only if the
                investment increases in price. The strategy cannot protect the
                investor against the risk of declining market prices.
              </p>
              <p>
                The general idea of the strategy assumes that prices will,
                eventually, always rise. Using this strategy on an individual
                stock without knowing about the company's details could prove
                dangerous because the strategy may encourage an investor to
                continue buying more stock at a time when they should simply
                exit the position. For less-informed investors, the strategy is
                far less risky on index funds than on individual stocks.
              </p>
              <p>
                Investors who use a dollar-cost averaging strategy will
                generally lower their cost basis in an investment over time. The
                lower cost basis will lead to less of a loss on investments that
                decline in price and generate greater gains on investments that
                increase in price.
              </p>
            </div>
          </article>

          <Button className="close-modal" variant="white" size="lg" onClick={() => setShow(false)}>
            Close
          </Button>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default DCAQuestion;
